import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  // Retorna el panel correspondiente a la pestaña seleccionada
  return (
    <div
      role="tabpanel"
      style={{ height: "100%" }}
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box sx={{ p: 2, height: "100%" }}>{children}</Box>}
    </div>
  );
}

// Validación de los tipos de las props del componente CustomTabPanel
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
